(() => {
  function initSubtabs(root = document) {
    const rails = root.querySelectorAll("[data-sms-subtabs]");
    rails.forEach((nav) => {
      if (nav.dataset.smsSubtabsInit === "1") return;
      nav.dataset.smsSubtabsInit = "1";

      const scroller = nav.querySelector("[data-sms-subtabs-scroller]");
      const prev = nav.querySelector("[data-sms-subtabs-prev]");
      const next = nav.querySelector("[data-sms-subtabs-next]");
      if (!scroller || !prev || !next) return;

      const getStep = () => {
        const tile = scroller.querySelector(".sms-subtabs__item");
        if (!tile) return 240;
        const gap = parseFloat(getComputedStyle(scroller).gap || "0") || 0;
        return tile.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const overflow = scroller.scrollWidth > scroller.clientWidth + 2;

        nav.classList.toggle("has-arrows", overflow);
        prev.hidden = !overflow;
        next.hidden = !overflow;

        if (!overflow) return;

        const maxScroll = scroller.scrollWidth - scroller.clientWidth;
        const x = scroller.scrollLeft;

        prev.disabled = x <= 1;
        next.disabled = x >= maxScroll - 1;
      };

      const scrollByDir = (dir) => {
        scroller.scrollBy({ left: dir * getStep(), behavior: "smooth" });
      };

      prev.addEventListener("click", () => scrollByDir(-1));
      next.addEventListener("click", () => scrollByDir(1));

      scroller.addEventListener(
        "scroll",
        () => window.requestAnimationFrame(update),
        { passive: true }
      );

      if ("ResizeObserver" in window) {
        const ro = new ResizeObserver(() => update());
        ro.observe(scroller);
        ro.observe(nav);
      } else {
        window.addEventListener("resize", update);
      }

      update();

      const imgs = scroller.querySelectorAll("img");
      imgs.forEach((img) => {
        if (img.complete) return;
        img.addEventListener("load", update, { once: true });
        img.addEventListener("error", update, { once: true });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => initSubtabs(document));
  document.addEventListener("shopify:section:load", (e) => initSubtabs(e.target));
})();
